<template>
  <div class="config_hang_wraper">
    <slot></slot>
    <!-- 行的最左侧图标插槽 -->
    <div class="config_hang_ele1" v-if="this.$slots['config_hang_ele1']">
      <slot name="config_hang_ele1"></slot>
    </div>
    <!-- 行的左侧文字内容插槽 //代号 20231206-1-->
    <div class="config_hang_ele2 z_ellipsis1" v-if="this.$slots['config_hang_ele2']"
      :class="selectState ? 'config_hang_ele2_select' : ''">
      <slot name="config_hang_ele2"></slot>
    </div>

    <!-- 行的左侧文字内容插槽,一次插入两行 //代号 20220921-1 //代号 20231206-1-->
    <div class="config_hang_ele2_wrap " v-if="this.$slots['config_hang_ele2_1', 'config_hang_ele2_2']">
      <slot></slot>
      <!-- 行的左侧文字2行插槽1 -->
      <div class="config_hang_ele2_1 z_ellipsis1" v-if="this.$slots['config_hang_ele2_1']"
        :class="selectState ? 'config_hang_ele2_select' : ''">
        <slot name="config_hang_ele2_1"></slot>
      </div>
      <!-- 行的左侧文字2行插槽2 -->
      <div class="config_hang_ele2_2 z_ellipsis1" v-if="this.$slots['config_hang_ele2_2']"
        :class="selectState ? 'config_hang_ele2_select' : ''">
        <slot name="config_hang_ele2_2"></slot>
      </div>
    </div>
    <!-- 行的右侧文字备注插槽 -->
    <div class="config_hang_ele3 z_ellipsis1" v-if="this.$slots['config_hang_ele3']">
      <slot name="config_hang_ele3"></slot>
    </div>

    <!-- 行的右侧文字设备状态插槽 -->
    <div class="config_hang_ele3_state_text z_ellipsis1" v-if="this.$slots['config_hang_ele3_state_text']">
      <slot name="config_hang_ele3_state_text"></slot>
    </div>

    <!-- 行的右侧文字备注插槽 022设备周期显示专用 -->
    <div class="config_hang_022_ele3 z_ellipsis1" v-if="this.$slots['config_hang_022_ele3']">
      <slot name="config_hang_022_ele3"></slot>
    </div>

    <!-- 行的右侧文字备注插槽  设备信息码 -->
    <div class="config_hang_ele3_1 z_ellipsis1" v-if="this.$slots['config_hang_ele3_1']">
      <slot name="config_hang_ele3_1"></slot>
    </div>

    <!-- 行的最右侧跳转箭头小图标插槽 -->
    <div class="config_hang_ele4" v-if="this.$slots['config_hang_ele4']">
      <slot name="config_hang_ele4"></slot>
    </div>
    <!-- 行的右侧图片选择样式 插槽 -->
    <div class="config_hang_xuanimg" v-if="this.$slots['config_hang_xuanimg']">
      <slot name="config_hang_xuanimg"></slot>
    </div>

    <!-- 行的右侧图片密码提示样式 插槽 -->
    <div class="config_hang_mimatishiimg" v-if="this.$slots['config_hang_mimatishiimg']">
      <slot name="config_hang_mimatishiimg"></slot>
    </div>

    <!-- 行的最右侧 修改图片样式插槽大图标 不需要配合input使用-->
    <div class="config_hang_xiugai" v-if="this.$slots['config_hang_da_img']">
      <slot name="config_hang_da_img"></slot>
    </div>

    <!-- 行的最右侧 修改图片样式插槽大图标  可以插入div元素 不需要配合input使用  //代号20220319-1-->
    <div class="config_hang_xiugai_view" v-if="this.$slots['config_hang_da_view_img']">
      <slot name="config_hang_da_view_img"></slot>
    </div>

    <!-- 行的最右侧 修改图片样式插槽大图标 配合下面的input使用-->
    <div class="config_hang_xiugai" v-if="this.$slots['config_hang_xiugai']" @click="xiugaiBtnHandle">
      <slot name="config_hang_xiugai"></slot>
    </div>
    <!-- 行的右侧input输入框插槽 -->
    <div class="config_hang_input_right" v-if="this.$slots['config_hang_input_right']">
      <slot name="config_hang_input_right"></slot>
    </div>

    <!-- 小时和分钟的提示文字 -->
    <div class="config_hang_ele_tishi z_ellipsis1" v-if="this.$slots['config_hang_ele_tishi']">
      <slot name="config_hang_ele_tishi"></slot>
    </div>
    <!-- 行的右侧input输入框插槽--小时 -->
    <div class="config_hang_input_right_hour" v-if="this.$slots['config_hang_input_right_hour']">
      <slot name="config_hang_input_right_hour"></slot>
    </div>
    <!-- 小时和分钟的中间插槽 -->
    <div class="config_hang_ele_fenhao z_ellipsis1" v-if="this.$slots['config_hang_ele_fenhao']">
      <slot name="config_hang_ele_fenhao"></slot>
    </div>
    <!-- 行的右侧input输入框插槽--分钟 -->
    <div class="config_hang_input_right_min" v-if="this.$slots['config_hang_input_right_min']">
      <slot name="config_hang_input_right_min"></slot>
    </div>

    <!-- 行的开关按钮图片的插槽 -->
    <div v-show="switchState >= 1" class="config_hang_switchBtn_open" v-if="this.$slots['config_hang_switchBtn_open']">
      <slot name="config_hang_switchBtn_open"></slot>
    </div>
    <!-- 行的开关按钮图片的插槽 -->
    <div v-show="switchState === 0" class="config_hang_switchBtn_close"
      v-if="this.$slots['config_hang_switchBtn_close']">
      <slot name="config_hang_switchBtn_close"></slot>
    </div>

    <!-- 行的未选中图片的插槽 -->
    <div v-show="selectState === false" class="config_hang_weixuan" v-if="this.$slots['config_hang_weixuan']">
      <slot name="config_hang_weixuan"></slot>
    </div>
    <!-- 行的选中图片的插槽 -->
    <div v-show="selectState === true" class="config_hang_xuanzhong" v-if="this.$slots['config_hang_xuanzhong']">
      <slot name="config_hang_xuanzhong"></slot>
    </div>

    <!-- 行的最左侧图标插槽 -->
    <div class="config_hang_input_img" v-if="this.$slots['config_hang_input_img']">
      <slot name="config_hang_input_img"></slot>
    </div>

    <div class="config_hang_input_left" v-if="this.$slots['config_hang_input_left']">
      <slot name="config_hang_input_left"></slot>
    </div>

    <!-- 中间参数下载按钮 -->
    <div class="config_hang_ele_xia_zai" v-if="this.$slots['config_hang_ele_xia_zai']">
      <slot name="config_hang_ele_xia_zai"></slot>
    </div>

    <!-- 周期定时任务设置页面的定时时间的显示和循环周期的显示 -->
    <div class="config_hang_ele_cycle_timing" v-if="this.$slots['config_hang_ele_cycle_timing']">
      <slot name="config_hang_ele_cycle_timing"></slot>
      <slot name="config_hang_ele_cycle_zhouqi"></slot>
    </div>
    <!-- <div class="config_hang_ele_cycle_zhouqi" v-if="this.$slots['config_hang_ele_cycle_zhouqi']">
    </div> -->

    <!-- 右侧添加按钮 -->

    <div class="config_button_hang_ele6 z_ellipsis1"
      :class="buttonHangEle6Warn ? 'config_button_hang_ele6_warn' : ''"
      v-if="this.$slots['config_button_hang_ele6']">
      <slot name="config_button_hang_ele6_img"></slot>
      <slot name="config_button_hang_ele6"></slot>
    </div>

    <div class="config_button_hang_ele5 z_ellipsis1"
      :class="buttonHangEle5Completed ? 'config_button_hang_ele5_completed' : ''"
      v-if="this.$slots['config_button_hang_ele5']">
      <slot name="config_button_hang_ele5_img"></slot>
      <slot name="config_button_hang_ele5"></slot>
    </div>
    <!-- 行的对象名称和对象区域名称插槽 -->
    <!-- <div class="config_hang_rule_name_wraper">
        <div class="hang_rule_region_name z_ellipsis1">{{userOneRule.regionName}}</div>
        <div class="hang_rule_device_name z_ellipsis1">{{userOneRule.remark}}</div>
    </div>-->

    <!-- <div class="config_hang_up_region_name z_ellipsis1" v-if="this.$slots['config_hang_up_region_name']">
      <slot name="config_hang_up_region_name"></slot>
    </div>
    <div class="config_hang_up_object_name z_ellipsis1" v-if="this.$slots['config_hang_up_object_name']">
      <slot name="config_hang_up_object_name"></slot>
    </div>-->

    <!-- 行的下划线 -->
    <div class="config_fen_ge_xian z_ellipsis1" v-if="fenGeXian === true"></div>
  </div>
</template>

<script>
export default {
  props: {
    fenGeXian: {
      type: Boolean,
      default: true
    },
    inputID: {
      type: String,
      default: 'xiugaiName'
    },
    switchState: {
      type: Number,
      default: 1
    },
    selectState: {
      type: Boolean,
      default: false ////配合打钩使用
    },
    selectState1: {
      type: Boolean,
      default: false ////用作选中字体变成蓝色 ,这个弃用了. 统一使用selectState //代号 20231206-1
    },
    buttonHangEle6Warn: {
      type: Boolean,
      default: false ////右侧第二按钮警告操作背景色
    },
    buttonHangEle5Completed: {
      type: Boolean,
      default: false ////右侧主操作按钮已成功完成
    }
  },
  methods: {
    xiugaiBtnHandle() {
      this.$nextTick(() => {
        //VUE的激活后聚焦的正确写法
        document.getElementById(this.inputID).focus() ////聚焦
      })
    }
  }
}

/**使用说明
 *
 * 举例 参数  :fenGeXian="false" 可不传  默认true  控制分割线是否需要
 *
 *      <config-hang :fenGeXian="false">
          <img slot="config_hang_ele1" src="~assets/img/config/shebei_guanyu.png" alt="">
          <span slot="config_hang_ele2" >关于</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt="">
        </config-hang>


        修改IMG和INPUT的配套使用，当需要用多个时需要传入inputID 确保ID的唯一性
        <config-hang inputID= "xiugaiName1">
          <span slot="config_hang_ele2">对象名称</span>
            <!-- img和input 配套使用  点击可以触发input的聚焦事件 -->
          <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
          <input type="text" slot="config_hang_input_right" id="xiugaiName1" placeholder="请输入场景名称" />
        </config-hang>
 */
</script>

<style>
.config_hang_wraper {
  /* height: 60px;
  width: 100%;
  line-height: 60px;
  padding: 0px 8px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer; */

  display: flex;
  box-sizing: border-box;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  height: 60px;
  width: 100%;
  line-height: 60px;
  padding: 0px 8px;
  position: relative;
}

.config_fen_ge_xian {
  display: inline-block;
  width: 100%;
  height: 1px;
  background-color: #f2f2f2;
  position: absolute;
  bottom: 0px;
  right: 0px;
}

.config_hang_wraper:hover {
  /* box-shadow: 1px -1px 4px var(--primary-color) inset; */
  background-color: rgba(68, 180, 253, 0.05);
}

.config_hang_ele1 {
  /* display: inline-block;
  width: 21px;
  height: 60px;
  margin-right: 5px; */

  display: flex;
  box-sizing: border-box;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  /* //代号 20231207-1 */
  margin-bottom: 2px;
}

.config_hang_ele1 img {
  /* display: inline-block; */
  height: 21px;
  width: 21px;
  /* height: 21px;
		width: 21px; */
  margin-right: 3px;
  /* position: relative;
  top: 4px; */
}

.config_hang_ele2 {
  display: inline-block;
  color: #282828;
  font-size: 18px;
  width: 300px;
  position: relative;
}

/* //代号 20220921-1 */
.config_hang_ele2_wrap {
  height: 80%;
  /* display: inline-block; */
  color: #282828;
  font-size: 18px;
  width: 400px;
  position: relative;

  /* #ifndef APP-PLUS-NVUE  */
  display: flex;
  box-sizing: border-box;
  /* #endif */

  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
}

.config_hang_ele2_1 {
  height: 50%;
  line-height: 100%;
  color: #282828;
  font-size: 18px;
  width: 400px;
  /* position: absolute; */

  /* #ifndef APP-PLUS-NVUE  */
  display: flex;
  box-sizing: border-box;
  /* #endif */
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: flex-start;
}

.config_hang_ele2_2 {
  height: 50%;
  line-height: 100%;
  color: #666;
  font-size: 16px;
  width: 400px;
  /* position: absolute; */

  /* #ifndef APP-PLUS-NVUE  */
  display: flex;
  box-sizing: border-box;
  /* #endif */
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: flex-start;
}

.config_hang_ele2_select {
  /* 行选中后的样式 */
  color: #40a8fb;
}

.config_hang_ele3 {
  display: inline-block;
  text-align: right;
  color: #999999;
  width: 150px;
  font-size: 16px;

  position: absolute;
  right: 40px;
}

.config_hang_ele3_state_text {
  display: inline-block;
  text-align: right;
  color: #999999;
  width: 150px;
  font-size: 16px;

  position: absolute;
  right: 80px;
}

.config_hang_022_ele3 {
  display: inline-block;
  text-align: right;
  color: #999999;
  width: 250px;
  font-size: 16px;

  position: absolute;
  right: 40px;
}

.config_hang_ele3_1 {
  display: inline-block;
  text-align: right;
  color: #999999;
  width: 200px;
  font-size: 16px;

  position: absolute;
  right: 120px;
}

.config_hang_xuanimg {
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: #f2f2f2;
  position: absolute;
  right: 40px;
  top: 14px;
}

.config_hang_xuanimg img {
  height: 21px;
  width: 21px;

  position: absolute;
  right: 7px;
  top: 7px;
}

.config_hang_mimatishiimg {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background-color: #f2f2f2;
  position: absolute;
  right: 40px;
  top: 19px;
}

.config_hang_mimatishiimg img {
  height: 16px;
  width: 14px;

  position: absolute;
  right: 5px;
  top: 4px;
}

.config_hang_ele4 img {
  height: 14px;
  width: 14px;
  position: absolute;
  right: 8px;
  top: 23px;
}

.config_hang_xiugai img {
  height: 21px;
  width: 21px;
  position: absolute;
  right: 10px;
  top: 20px;
}

/* //代号20220319-1 */
.config_hang_xiugai_view div {
  height: 100%;
  width: 60px;
  background: transparent;
  position: absolute;
  right: 0px;
  top: 0px;
}

/* //代号20220319-1 */
.config_hang_xiugai_view img {
  height: 21px;
  width: 21px;
  position: absolute;
  right: 10px;
  top: 20px;
}

.config_hang_input_right input {
  color: #999999;
  font-size: 16px;
  display: inline-block;
  /* border: 1px solid #f2f2f2; */
  background: none;
  outline: none;
  border: none;
  padding: 0px;
  /* border-radius: 0px; */
  height: 40px;
  width: 200px;
  text-align: right;
  position: absolute;
  top: 11px;
  right: 40px;
}

.config_hang_input_right input:focus {
  color: #40a8fb;
  outline: none;
  border: 0px solid blue;
}

.config_hang_ele_tishi {
  position: absolute;
  top: 1px;
  right: 180px;
  font-size: 16px;
  color: #cccccc;
}

.config_hang_input_right_hour input {
  color: #999999;
  font-size: 16px;
  display: inline-block;
  /* border: 1px solid #f2f2f2; */
  background: none;

  padding: 0px;
  /* border-radius: 0px; */
  height: 40px;
  width: 50px;
  text-align: center;
  position: absolute;
  top: 11px;
  right: 120px;
}

.config_hang_ele_fenhao {
  position: absolute;
  top: 1px;
  right: 100px;
  font-size: 30px;
  color: #999999;
}

.config_hang_input_right_min input {
  color: #999999;
  font-size: 16px;
  display: inline-block;
  /* border: 1px solid #f2f2f2; */
  background: none;

  padding: 0px;
  /* border-radius: 0px; */
  height: 40px;
  width: 50px;
  text-align: center;
  position: absolute;
  top: 11px;
  right: 40px;
}

.config_hang_switchBtn_open img {
  height: 28px;
  width: 46px;
  position: absolute;
  right: 10px;
  top: 18px;
}

.config_hang_switchBtn_close img {
  height: 28px;
  width: 46px;
  position: absolute;
  right: 10px;
  top: 18px;
}

.config_hang_weixuan img {
  height: 21px;
  width: 21px;
  position: absolute;
  right: 10px;
  top: 20px;
}

.config_hang_xuanzhong img {
  height: 21px;
  width: 21px;
  position: absolute;
  right: 10px;
  top: 20px;
}

.config_hang_input_img {
  display: inline-block;
  /* width: 40px; */
  height: 60px;
  margin-right: 5px;
}

.config_hang_input_img img {
  display: inline-block;
  height: 24px;
  width: 24px;
  position: relative;
  top: 6px;
}

.config_hang_input_left {
  display: inline-block;
  width: 95%;
  position: relative;
  top: -2px;
}

.config_hang_input_left input {
  display: inline-block;
  background: none;

  width: 100%;
  font-size: 16px;
  border: none;
  /* 属性 聚焦时切换成英文输入法 */
  ime-mode: inactive;

  position: relative;
  top: 2px;
}

.config_hang_ele_xia_zai {
  width: 100%;
  text-align: center;
  font-size: 18px;
  color: var(--primary-color);
}

.config_hang_ele_xia_zai:active {
  color: #a0a3a5;
}

.config_hang_ele_cycle_timing {
  /* height: 50%;
  width: 300px;
  position: absolute;
  right: 10px;
  top: 20px; */

  display: inline-block;
  text-align: right;
  color: var(--primary-color);

  height: 60px;
  width: 300px;
  font-size: 14px;

  position: absolute;
  right: 80px;
  top: 0px;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.config_hang_ele_cycle_timing:active {
  color: #999999;
}

/* .config_hang_ele_cycle_timing:hover{
  color: #999999;
} */

.config_hang_ele_cycle_timing span {
  display: inline-block;
  height: 21px;
  text-align: center;

  line-height: 21px;
}

.config_button_hang_ele5 {
  color: #ffffff;
  /* width: 150px; */
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  position: absolute;
  top: 12px;
  right: 220px;
  padding: 2px 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--primary-color);

  cursor: pointer;
}

div.config_button_hang_ele5 span {
  color: #ffffff;
}

.config_button_hang_ele5:active {
  background: #a0a3a5;
}

.config_button_hang_ele5_completed,
.config_button_hang_ele5_completed:active {
  background: var(--common-success-color);
  cursor: default;
}

.config_button_hang_ele5 img {
  height: 18px;
  width: 18px;
  margin-right: 3px;
}

.config_button_hang_ele6 {
  color: #ffffff;
  /* width: 150px; */
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  position: absolute;
  top: 12px;
  right: 310px;
  padding: 2px 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--primary-color);

  cursor: pointer;
}

.config_button_hang_ele6_warn {
  background-color: var(--primay-warn-color);
}

div.config_button_hang_ele6 span {
  color: #ffffff;
}

.config_button_hang_ele6:active {
  background: #a0a3a5;
}

.config_button_hang_ele6 img {
  height: 18px;
  width: 18px;
  margin-right: 3px;
}
</style>
